import type * as React from 'react';
import { cn } from '../../lib/utils.ts';

/**
 * A light tooltip shown on hover and keyboard focus. The control's own
 * aria-label carries the name for screen readers, so the tooltip is hidden
 * from them to avoid reading the name twice.
 */
export function Tooltip({ label, children, side = 'bottom' }: { label: string; children: React.ReactElement; side?: 'top' | 'bottom' | 'left' | 'right' }) {
  const position = {
    bottom: 'top-full left-1/2 mt-1.5 -translate-x-1/2',
    top: 'bottom-full left-1/2 mb-1.5 -translate-x-1/2',
    left: 'right-full top-1/2 mr-1.5 -translate-y-1/2',
    right: 'left-full top-1/2 ml-1.5 -translate-y-1/2',
  }[side];
  return (
    <span className="group/tooltip relative inline-flex">
      {children}
      <span
        role="tooltip"
        aria-hidden
        className={cn(
          'pointer-events-none absolute z-50 whitespace-nowrap rounded-md border border-border bg-popover px-2.5 py-1.5 text-xs font-medium text-popover-foreground opacity-0 shadow-md transition-opacity delay-300 group-hover/tooltip:opacity-100 group-has-[:focus-visible]/tooltip:opacity-100',
          position,
        )}
      >
        {label}
      </span>
    </span>
  );
}

/** Kept for compatibility with the provider used around the app. */
export function TooltipProvider({ children }: { children: React.ReactNode; delayDuration?: number }) {
  return <>{children}</>;
}
